import { Provider } from '@angular/core';
import { AuthHttpInterceptor } from '@auth0/auth0-angular';
import { HTTP_AUTH_INTERCEPTOR } from '@ups/xplat/core';
import { IssuerAwareAuthInterceptor } from './issuer-aware-auth.interceptor';

/**
 * Binds MyHttpClientFactory's HTTP_AUTH_INTERCEPTOR to IssuerAwareAuthInterceptor (#29709): Entra sessions attach the
 * facade's Bearer, Auth0 sessions get the stock interceptor behind the 20s acquire bound, renew-first 401 recovery and
 * latched re-login (#32087/#32089). Spread it AFTER importing AuthModule, whose own binding is the stock interceptor.
 * Used by buildEntraMsalProviders({ bindHttpAuthInterceptor: true }) and by Auth0-only apps such as web-sparta (#32088).
 */
export function provideIssuerAwareHttpAuth(): Provider[] {
  return [
    // The delegate must be resolvable by its own class token: IssuerAwareAuthInterceptor calls
    // injector.get(AuthHttpInterceptor) for auth0-issuer requests, and the xplat AuthModule only binds the class AS the
    // seam token (useClass), which registers nothing under AuthHttpInterceptor itself (NG0201 at runtime without this).
    AuthHttpInterceptor,
    IssuerAwareAuthInterceptor,
    {
      provide: HTTP_AUTH_INTERCEPTOR,
      useExisting: IssuerAwareAuthInterceptor,
    } satisfies Provider,
  ];
}
